export function isTest(): boolean {
  if (typeof process === 'undefined') {
    return false;
  }
  return process?.env?.NODE_ENV === 'test';
}

export function isBrowser(win: Window = globalThis.window): win is Window {
  return win instanceof Window;
}

// Add rules here to determine if tracking is allowed on the current browser
export function isTrackingAllowedOnBrowser(): boolean {
  return isBrowser();
}
